import { GridCol, GridContainer, GridRow, HR, Icon, ICONS, Spacer } from '@bob/library'
import { AppProviderContext } from '@websrc/App/AppContext'
import { AssetProps } from '@websrc/App/Components/Asset/Asset'
import { LessonCard } from '@websrc/App/Components/Lesson/Card/LessonCard'
import { useLocale } from '@websrc/App/Hooks/useLocale'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { lessonsLandingPage_searchLessons_hits_hit } from '@websrc/Typings/Dante/lessonsLandingPage'
import { UnitPlanInfo, UnitPlanInfoProps } from '@websrc/UnitPlan/Info/UnitPlanInfo'
import React, { FC, useContext } from 'react'

import * as SC from './UnitPlan.style'

export interface UnitPlanProps {
  asset: AssetProps | null
  unitPlanInfo: UnitPlanInfoProps
  unitPlanLessons: lessonsLandingPage_searchLessons_hits_hit[]
}

export const UnitPlan: FC<UnitPlanProps> = ({ asset, unitPlanLessons, unitPlanInfo }) => {
  const t = useStaticText()
  const locale = useLocale()
  const { matomoPageTemplate } = useContext(AppProviderContext)

  return (
    <>
      <SC.CustomHeadroom disableInlineStyles={true} pinStart={20}>
        <GridContainer>
          <SC.MainNavigation>
            <SC.LinkButton
              aria-label={t.plans_lessons_worksheets.back_to_lessons_plans}
              to={`/${locale}/lessons`}
            >
              <Icon icon={ICONS.ARROW_LEFT} size={20} />
              <Icon icon={ICONS.ARROW_LEFT} size={20} />
              {t.plans_lessons_worksheets.back_to_lessons_plans}
            </SC.LinkButton>
          </SC.MainNavigation>
        </GridContainer>
      </SC.CustomHeadroom>
      <GridContainer>
        <SC.Cover
          sizes={'(max-width: 1023px) 100vw, 86vw'}
          srcSetWidths={[600, 900, 1700]}
          {...asset}
        />
        <GridCol>
          <UnitPlanInfo {...unitPlanInfo} />
          <HR light={true} />
          <Spacer.Height size={20} />
        </GridCol>
        <GridCol>
          <SC.Title>{t.plans_lessons_worksheets.lessons}</SC.Title>
        </GridCol>
        <GridRow>
          {unitPlanLessons.map((lesson, key) => (
            <LessonCard
              key={key}
              onClick={() =>
                matomo.trackEvent(
                  'engagement',
                  matomoPageTemplate,
                  [unitPlanInfo.title],
                  [lesson.title],
                  'block'
                )
              }
              {...lesson}
            />
          ))}
        </GridRow>
      </GridContainer>
    </>
  )
}
